export default __webpack_public_path__ + "static/media/_IMG7359.0efa38a1.jpg";